import React from 'react';
import ReactDOM from 'react-dom';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import classNames from 'classnames';

/**
 * Item number cell
 *
 */
export default React.createClass({
  displayName: 'ItemNumberCell',

  propTypes: {
    itemNumber: React.PropTypes.number.isRequired,
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    rowIndex: React.PropTypes.number.isRequired,
  },

  render() {
    const { isEditing, isSelected, autoCountCues } = this.props;

    return (
      <div
        className={classNames('cs-cell-item-number', {
          'cs-cell-editing': isEditing,
          'cs-cell-selected': isSelected,
        })}
        onClick={this._handleClick}
      >
        {isEditing ? this._getMutable(autoCountCues) : this._getReadOnly()}
      </div>
    );
  },

  _getReadOnly() {
    return this._getCellText();
  },

  _getMutable(autoCountCues) {
    return (
      <input
        type={autoCountCues ? 'number' : 'text'}
        ref="itemNumberInput"
        autoFocus
        onFocus={(e) => e.target.select()}
        onBlur={this._stopEditing}
        // Make this uncontrolled fixes Issue #4192 with still functioning properly
        defaultValue={this._getCellText()}
        onKeyDown={(e) => {
          // Fix for cursor shifting when entering letters/period into input when
          // auto item numbers is on (keyCode 190 is period)
          if (autoCountCues && e.keyCode === 190) {
            return e.preventDefault();
          }

          if (e.keyCode === 9) {
            e.preventDefault();
            this._handleTab();
          }
        }}
      />
    );
  },

  _handleClick() {
    const { isEditing, isSelected, autoCountCues, rowIndex } = this.props;

    if (autoCountCues && rowIndex > 0) return;

    if (!isEditing && !isSelected) {
      this._select();
    } else if (isSelected && !isEditing) {
      this._startEditing();
    }
  },

  _handleTab() {
    const { isEditing } = this.props;

    if (isEditing) {
      this._stopEditing();
      CuesheetCursorActions.moveCursorRight();
    }
  },

  _getCellText() {
    const { autoCountCues } = this.props;

    if (autoCountCues) {
      return this.props.itemNumber.toString();
    }

    return this.props.item.get('number');
  },

  _select() {
    CuesheetCellActions.selectItemCell(
      this.props.rowIndex,
      EditableCellTypes.ItemNumber,
    );
  },

  _startEditing() {
    CuesheetCellActions.startEditingItemCell(
      this.props.rowIndex,
      EditableCellTypes.ItemNumber,
    );
  },

  _stopEditing() {
    let val = ReactDOM.findDOMNode(this.refs.itemNumberInput).value;
    const { autoCountCues } = this.props;

    // When auto item numbers is on and an empty value is submitted we default it to 0
    if (autoCountCues && val.length < 1) val = 0;

    CuesheetCellActions.saveItemNumber(this.props.rowIndex, val);
  },
});
